import { useState, useCallback, useEffect, useRef } from "react";
import Header from "../Header/Header.js";
import ClientData from "./ClientData.js";
import { api } from "../../utils/api.js";
import { ENDPOINTS as E } from "../../utils/endpoints.js";

function ClientRoom({ username, handleLogout }) {
  const [freshUserInfo, setFreshUserInfo] = useState({});
  const [vacancies, setVacancies] = useState([]);
  const [responds, setResponds] = useState([]);
  const [isVacanciesOpened, setVacanciesOpened] = useState(true);
  const [isFirstReq, setFirstReq] = useState(true);
  const [image, setImage] = useState(null);
  const [headerFunction, setHeaderFunction] = useState(null);

  const lastRequestId = useRef(0);
  const role = 1;
  /*   const errorText =
    "Ошибка сервера, попробуйте обновить страницу или повторить позже."; */
  const name =
    !username || username === "" ? localStorage.getItem("user") : username;
  const ink = +name.replaceAll(/\D/gi, "").slice(0, 4);

  const updateResponds = useCallback((obj) => {
    const { data } = obj;
    const name = data?.[0]?.company || null;
    setResponds(data);
    return name;
  }, []);

  const refreshResponds = useCallback(
    async (obj) => {
      const target = { ...obj, ink };
      await api
        .post(E.UPD_RESP_INFO, role, { data: target } /*, errorText*/)
        .then((res) => {
          if (!res.success) return;
        });

      api
        .post(E.GET_RESPONDS, role, { data: [ink] } /*, errorText*/)
        .then((res) => {
          if (res.success) {
            const name = updateResponds(res);
            setFreshUserInfo((userInfo) => ({ ...userInfo, name }));
          }
        });
    },
    [ink, updateResponds]
  );

  const createImageUrl = async (bufferData, mimeType) => {
    try {
      let blob;

      if (
        bufferData &&
        bufferData.type === "Buffer" &&
        Array.isArray(bufferData.data)
      ) {
        const uint8Array = new Uint8Array(bufferData.data);
        blob = new Blob([uint8Array], { type: mimeType });
      } else if (
        bufferData instanceof Uint8Array ||
        bufferData instanceof ArrayBuffer
      ) {
        blob = new Blob([bufferData], { type: mimeType });
      } else if (bufferData && bufferData.buffer instanceof ArrayBuffer) {
        blob = new Blob([bufferData.buffer], { type: mimeType });
      } else if (
        typeof bufferData === "string" &&
        bufferData.startsWith("\\x")
      ) {
        const hexString = bufferData.substring(2);
        const bytes = new Uint8Array(hexString.length / 2);

        for (let i = 0; i < hexString.length; i += 2) {
          bytes[i / 2] = parseInt(hexString.substr(i, 2), 16);
        }

        blob = new Blob([bytes], { type: mimeType });
      } else {
        console.warn("Unsupported buffer data type:", bufferData);
        throw new Error("Unsupported data type");
      }

      if (!blob || blob.size === 0) {
        console.warn("Empty or invalid blob created");
        return null;
      }

      return URL.createObjectURL(blob);
    } catch (err) {
      console.error("Error creating image from buffer:", err);
      return null;
    }
  };

  const getData = useCallback(async () => {
    const requestId = ++lastRequestId.current;

    if (isFinite(ink) && ink > 0) {
      try {
        const info = {};

        if (isFirstReq) {
          info.need_image = true;
        }
        const resp = await Promise.all([
          api.post(E.GET_VACS, role, { data: [ink] } /*, errorText*/),
          api.post(E.GET_RESPONDS, role, { data: [ink] } /*, errorText*/),
          api.post(
            E.GET_CLIENT_INFO,
            role,
            { data: [ink, info] } /*, errorText*/
          ),
        ]);

        if (requestId !== lastRequestId.current) {
          return;
        }

        let userInfo = {};
        if (resp[0].success) {
          const { data } = resp[0];
          const updatedVacs = data.reduce((acc, cur) => {
            if (!acc.length) {
              acc.push(cur);
            } else {
              const ind = acc.findIndex((item) => item.title === cur.title);

              if (ind < 0) {
                acc.push(cur);
              } else {
                const maxAddress =
                  acc[ind].address.length > cur.address.length
                    ? acc[ind].address
                    : cur.address;
                const minAddress =
                  acc[ind].address.length > cur.address.length
                    ? cur.address
                    : acc[ind].address;

                if (maxAddress.includes(minAddress)) {
                  acc[ind].address = minAddress;
                  acc[ind].count =
                    +acc[ind].count === +cur.count
                      ? +cur.count
                      : +acc[ind].count + +cur.count;
                  acc[ind].old_cnt =
                    +acc[ind].old_cnt === +cur.old_cnt
                      ? +cur.old_cnt
                      : +acc[ind].old_cnt + +cur.old_cnt;
                } else {
                  acc.push(cur);
                }
              }
            }
            return acc;
          }, []);
          const arr = updatedVacs.map((i) =>
            Object.assign(i, { count: +i.count, old_cnt: +i.old_cnt })
          );
          setVacancies(arr);
          userInfo = { ...userInfo, responds: arr };
          setFreshUserInfo(userInfo);
        }
        if (resp[1].success) {
          const name = updateResponds(resp[1]);
          userInfo = { ...userInfo, name };
          setFreshUserInfo(userInfo);
        }
        if (resp[2].success) {
          const { data } = resp[2];

          if (data) {
            setFirstReq(false);

            if (!userInfo.name) {
              const name = data.name;
              userInfo = { ...userInfo, name };
              setFreshUserInfo(userInfo);
            }

            if (data.avatar && data.mime_type) {
              const imageUrl = await createImageUrl(
                data.avatar,
                data.mime_type
              );
              if (imageUrl) {
                setImage(imageUrl);
              }
            }
          }
        }
      } catch (err) {
        if (requestId !== lastRequestId.current) return;
        console.error("Error fetching data:", err.message);
      }
    }
  }, [username, ink, updateResponds]);

  useEffect(() => {
    const intervalId = setInterval(getData, 60000);

    return () => {
      clearInterval(intervalId);
    };
  }, [getData]);

  useEffect(() => {
    document.documentElement.style.setProperty("--bg-color", "#fff");
    getData();
  }, [getData]);

  const handleFunctionFromClientData = useCallback((fn) => {
    setHeaderFunction(() => fn);
  }, []);

  return (
    <main>
      <Header
        isClient={true}
        handleLogout={handleLogout}
        customFunction={headerFunction}
      />
      <ClientData
        freshUserInfo={freshUserInfo}
        isVacanciesOpened={isVacanciesOpened}
        vacancies={vacancies}
        responds={responds}
        image={image}
        ink={ink}
        setVacanciesOpened={setVacanciesOpened}
        setResponds={refreshResponds}
        setImage={setImage}
        refreshData={getData}
        onRegisterFunction={handleFunctionFromClientData}
      />
    </main>
  );
}

export default ClientRoom;
